import { actionCableClient } from "./actioncable-client";
import { ActionCableCartUpdatePayload } from "./types";

const CART_CHANNEL = "CartChannel";

export class ActionCableService {
  private static instance: ActionCableService;

  public static getInstance(): ActionCableService {
    if (!ActionCableService.instance) {
      ActionCableService.instance = new ActionCableService();
    }
    return ActionCableService.instance;
  }

  public subscribeToCartUpdates(
    cartToken: string,
    onUpdate: (payload: ActionCableCartUpdatePayload) => void,
  ): () => void {
    const subscription =
      actionCableClient.subscribe<ActionCableCartUpdatePayload>(
        CART_CHANNEL,
        { cart_token: cartToken },
        {
          received: (data) => {
            try {
              onUpdate(data);
            } catch (error) {
              console.error(
                `[ActionCableService] Error processing cart update for ${cartToken}:`,
                error,
              );
              throw error;
            }
          },
          connected: () => {},
          disconnected: () => {
            console.warn(
              `[ActionCableService] Disconnected from cart updates for ${cartToken}`,
            );
          },
          rejected: () => {
            console.error(
              `[ActionCableService] Subscription rejected for cart ${cartToken}`,
            );
          },
        },
      );

    if (!subscription) {
      console.error(
        `[ActionCableService] Failed to subscribe to ${CART_CHANNEL}`,
      );
      return () => {};
    }

    return () => {
      actionCableClient.unsubscribe(CART_CHANNEL, cartToken);
    };
  }
}

export const actionCableService = ActionCableService.getInstance();
